// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3z0Rt","info":"PatientInfo_info__1TLcB"};